/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { tryDefine } from '@tylertech/forge-core';
import { KEY_ITEM_TAG_NAME, KeyItemComponent } from './key-item';
export * from './key-item';
export function defineKeyItemComponent() {
    tryDefine(KEY_ITEM_TAG_NAME, KeyItemComponent);
}
